import { MaterialDto } from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';

import { useMemo } from 'react';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import styles from './material-info.module.css';
import { materialInfoFieldSource } from '../../../View/FieldSource';

const MaterialInfo: React.FC<{ material: MaterialDto }> = ({ material }) => {
  const fieldSource = useMemo(
    () =>
      material
        ? [
            ...materialInfoFieldSource({
              data: material,
            }),
          ]
        : [],
    [material]
  );

  if (!material) return null;

  return (
    <div className={styles.container}>
      {fieldSource.map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>

          <span className={styles.viewItemValue}>
            {item.value || EMPTY_FIELD_PLACEHOLDER}
          </span>
        </div>
      ))}
    </div>
  );
};

export default MaterialInfo;
